require('./dist/angular-input-modified');
module.exports = 'ngInputModified';



//////////////////
// WEBPACK FOOTER
// ./~/angular-input-modified/index.js
// module id = 570
// module chunks = 1